<template>
  <div
    class="app-toggle"
    :class="{
      'app-toggle--active': props.modelValue,
      'app-toggle--disabled': props.disabled,
    }"
    @click="handleClick"
  >
    <div class="app-toggle__circle">
      <span class="material-icons">all_inclusive</span>
    </div>
  </div>
</template>

<script setup>
  // eslint-disable-next-line no-undef
  defineOptions({ name: 'AppToggle' });

  // eslint-disable-next-line no-undef
  const props = defineProps({
    modelValue: Boolean,
    disabled: Boolean,
    customClass: {
      type: [String, Object],
      default: '',
    },
  });

  // eslint-disable-next-line no-undef
  const emit = defineEmits(['update:modelValue', 'click']);

  // eslint-disable-next-line no-undef
  function handleClick() {
    if (props.disabled) return;
    // eslint-disable-next-line no-undef
    emit('update:modelValue', !props.modelValue);
    // eslint-disable-next-line no-undef
  }
</script>

<style scoped>
  .app-toggle {
    width: 64px;
    height: 32px;
    background-color: #b5b5c9;
    border-radius: 999px;
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    transition: background-color 0.3s;
  }

  .app-toggle--active {
    background-color: rgba(147, 147, 236, 1);
  }

  .app-toggle--disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .app-toggle__circle {
    width: 28px;
    height: 28px;
    background-color: white;
    border-radius: 50%;
    position: absolute;
    left: 2px;
    top: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  }

  .app-toggle--active .app-toggle__circle {
    transform: translateX(32px);
  }

  .material-icons {
    font-size: 16px;
    color: #333;
  }
</style>
